import { gql } from '@apollo/client';
const GET_ORDER_SUPPLIERS = gql `
  query GetOrderSuppliers($id: ID!) {
    node(id: $id) {
      ... on OrderNode {
        id
        orderId
        componentVariantsBySuppliers {
          id
          orderSupplier {
            id
            supplier {
              id
              code
              shortName
              fullName
            }
          }
          componentVariants {
            id
            name
            calculatedConsumption
            consumptionOverride
            consumptionEditAvailable
            componentAttributesPL
            variantAttributesPL
            componentAttributesEN
            variantAttributesEN
            ready
            productionStartDate
            productionEndDate
            deliveries {
              id
              deliveryType
              quantityPlanned
              quantityCollected
              plannedDate
              collectedDate
              timelineStartDate
              timelineEndDate
              status
              deliveryOrdinal
            }
            orderOperatorOfOrder {
              id
              orderOperator {
                id
                name
              }
            }
            componentCategory {
              id
              type
              typeLabelPL
              typeLabelEN
              precision
              consumptionType {
                id
                name
                labelPL
                labelEN
                integerValues
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_ORDER_SUPPLIERS;
